import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import GeoView from 'views/customers/geo'; // Importing GeoView component
import MoneyView from 'views/machine/statistics/money'; // Importing MoneyView component
import MarketingView from 'views/machine/statistics/marketing'; // Importing MarketingView component
import MarketingVsRegistrosView from 'views/machine/statistics/marketingvsregistros'; // Importing MarketingVsRegistrosView component
import StatAgeView from 'views/machine/statistics/age'; // Importing StatAgeView component
import PositionsView from 'views/customers/positions'; // Importing PositionsView component
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the StatisticsMachineRegisterView.
 * @extends JetView
 */
export default class StatisticsMachineRegisterView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        var toDateLocal = // Variable to hold the current date and time in local format
            new Date().getFullYear() +
            ':' +
            ('00' + (new Date().getMonth() + 1)).slice(-2) +
            ':' +
            ('00' + new Date().getDate()).slice(-2) +
            ' ' +
            ('00' + new Date().getHours()).slice(-2) +
            ':' +
            ('00' + new Date().getMinutes()).slice(-2) +
            ':' +
            ('00' + new Date().getSeconds()).slice(-2);
        var fromDateLocal; // Variable to hold the starting date for filtering
        webix.ui.fullScreen(); // Set the UI to full screen mode
        return {
            rows: [
                // Main layout structure
                {
                    view: 'toolbar', // Toolbar for date selection buttons
                    paddingY: 2,
                    cols: [
                        {
                            view: 'button', // Button for today's date
                            value: _('Hoy'),
                            click: () => {
                                // Click event handler
                                fromDateLocal = // Calculate today's date in local format
                                    webix.Date.add(new Date(), 0, 'day').getFullYear() +
                                    ':' +
                                    ('00' + (webix.Date.add(new Date(), 0, 'day').getMonth() + 1)).slice(-2) +
                                    ':' +
                                    ('00' + webix.Date.add(new Date(), 0, 'day').getDate()).slice(-2) +
                                    ' ' +
                                    ('00' + webix.Date.add(new Date(), 0, 'day').getHours()).slice(-2) +
                                    ':' +
                                    ('00' + webix.Date.add(new Date(), 0, 'day').getMinutes()).slice(-2) +
                                    ':' +
                                    ('00' + webix.Date.add(new Date(), 0, 'day').getSeconds()).slice(-2);
                                const dateFilter = {
                                    // Create date filter object
                                    FromDateLocal: fromDateLocal,
                                    ToDateLocal: toDateLocal,
                                    day: 'Hoy',
                                };
                                console.log(dateFilter); // Log the date filter
                                this.app.callEvent('statisticsAgent:date', [
                                    // Trigger event with date filter
                                    dateFilter,
                                ]);
                            },
                        },
                        {
                            view: 'button', // Button for yesterday's date
                            value: _('Ayer'),
                            click: () => {
                                // Click event handler
                                fromDateLocal = // Calculate yesterday's date in local format
                                    webix.Date.add(new Date(), -1, 'day').getFullYear() +
                                    ':' +
                                    ('00' + (webix.Date.add(new Date(), -1, 'day').getMonth() + 1)).slice(-2) +
                                    ':' +
                                    ('00' + webix.Date.add(new Date(), -1, 'day').getDate()).slice(-2) +
                                    ' ' +
                                    ('00' + webix.Date.add(new Date(), -1, 'day').getHours()).slice(-2) +
                                    ':' +
                                    ('00' + webix.Date.add(new Date(), -1, 'day').getMinutes()).slice(-2) +
                                    ':' +
                                    ('00' + webix.Date.add(new Date(), -1, 'day').getSeconds()).slice(-2);
                                const dateFilter = {
                                    // Create date filter object
                                    FromDateLocal: fromDateLocal,
                                    ToDateLocal: toDateLocal,
                                    day: 'Ayer',
                                };
                                console.log(dateFilter); // Log the date filter
                                this.app.callEvent('statisticsAgent:date', [
                                    // Trigger event with date filter
                                    dateFilter,
                                ]);
                            },
                        },
                        {
                            view: 'button', // Button for the last 3 days
                            value: _('Ultimos 3 días'),
                            click: () => {
                                // Click event handler
                                fromDateLocal = // Calculate the date 3 days ago in local format
                                    webix.Date.add(new Date(), -3, 'day').getFullYear() +
                                    ':' +
                                    ('00' + (webix.Date.add(new Date(), -3, 'day').getMonth() + 1)).slice(-2) +
                                    ':' +
                                    ('00' + webix.Date.add(new Date(), -3, 'day').getDate()).slice(-2) +
                                    ' ' +
                                    ('00' + webix.Date.add(new Date(), -3, 'day').getHours()).slice(-2) +
                                    ':' +
                                    ('00' + webix.Date.add(new Date(), -3, 'day').getMinutes()).slice(-2) +
                                    ':' +
                                    ('00' + webix.Date.add(new Date(), -3, 'day').getSeconds()).slice(-2);
                                const dateFilter = {
                                    // Create date filter object
                                    FromDateLocal: fromDateLocal,
                                    ToDateLocal: toDateLocal,
                                    day: 'Ultimos 3 días',
                                };
                                console.log(dateFilter); // Log the date filter
                                this.app.callEvent('statisticsAgent:date', [
                                    // Trigger event with date filter
                                    dateFilter,
                                ]);
                            },
                        },
                        {
                            view: 'button', // Button for the last 7 days
                            value: _('Ultimos 7 días'),
                            click: () => {
                                // Click event handler
                                fromDateLocal = // Calculate the date 7 days ago in local format
                                    webix.Date.add(new Date(), -7, 'day').getFullYear() +
                                    ':' +
                                    ('00' + (webix.Date.add(new Date(), -7, 'day').getMonth() + 1)).slice(-2) +
                                    ':' +
                                    ('00' + webix.Date.add(new Date(), -7, 'day').getDate()).slice(-2) +
                                    ' ' +
                                    ('00' + webix.Date.add(new Date(), -7, 'day').getHours()).slice(-2) +
                                    ':' +
                                    ('00' + webix.Date.add(new Date(), -7, 'day').getMinutes()).slice(-2) +
                                    ':' +
                                    ('00' + webix.Date.add(new Date(), -7, 'day').getSeconds()).slice(-2);
                                const dateFilter = {
                                    // Create date filter object
                                    FromDateLocal: fromDateLocal,
                                    ToDateLocal: toDateLocal,
                                    day: 'Ultimos 7 días',
                                };
                                console.log(dateFilter); // Log the date filter
                                this.app.callEvent('statisticsAgent:date', [
                                    // Trigger event with date filter
                                    dateFilter,
                                ]);
                            },
                        },
                        {
                            view: 'button', // Button for the last 30 days
                            value: _('Ultimos 30 días'),
                            click: () => {
                                // Click event handler
                                fromDateLocal = // Calculate the date 30 days ago in local format
                                    webix.Date.add(new Date(), -30, 'day').getFullYear() +
                                    ':' +
                                    ('00' + (webix.Date.add(new Date(), -30, 'day').getMonth() + 1)).slice(-2) +
                                    ':' +
                                    ('00' + webix.Date.add(new Date(), -30, 'day').getDate()).slice(-2) +
                                    ' ' +
                                    ('00' + webix.Date.add(new Date(), -30, 'day').getHours()).slice(-2) +
                                    ':' +
                                    ('00' + webix.Date.add(new Date(), -30, 'day').getMinutes()).slice(-2) +
                                    ':' +
                                    ('00' + webix.Date.add(new Date(), -30, 'day').getSeconds()).slice(-2);
                                const dateFilter = {
                                    // Create date filter object
                                    FromDateLocal: fromDateLocal,
                                    ToDateLocal: toDateLocal,
                                    day: 'Ultimos 30 días',
                                };
                                console.log(dateFilter); // Log the date filter
                                this.app.callEvent('statisticsAgent:date', [
                                    // Trigger event with date filter
                                    dateFilter,
                                ]);
                            },
                        },
                        {
                            view: 'form', // Form for date range selection
                            class: 'date-dashboard',
                            id: 'myform',
                            type: 'clean',
                            height: 30,
                            elements: [
                                {
                                    view: 'daterangepicker', // Date range picker component
                                    name: 'regDateRange',
                                    id: 'fechaRango',
                                    placeholder: _('Seleccione Fecha'),
                                    format: webix.Date.dateToStr('%d %M %Y'), // Date format for display
                                },
                            ],
                            padding: 0,
                        },
                    ],
                },
                {
                    type: 'wide', // Main content area
                    rows: [
                        {
                            gravity: 2,
                            type: 'wide',
                            cols: [
                                MarketingView, // Marketing statistics view
                                { view: 'resizer' }, // Resizer between columns
                                {
                                    type: 'wide',
                                    minWidth: 370,
                                    rows: [MarketingVsRegistrosView], // Marketing vs Registrations view
                                },
                            ],
                        },
                        {
                            type: 'wide',
                            cols: [MoneyView, { view: 'resizer' }, StatAgeView], // Money and Age statistics views
                        },
                    ],
                    ready: function () {
                        // Ready event handler
                    },
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     */
    init() {
        var initThis = this; // Reference to the current instance
        const cur_user = this.getParam('user', true); // Get the current user parameter
        this.on(this.app, 'statisticsAgent:date', (date) => {
            // Event listener for date changes
            var dateRange = date; // Date range received from the event
            webix // AJAX request to fetch marketing statistics
                .ajax()
                .headers({
                    'Content-type': 'application/json', // Set content type for the request
                })
                .post(
                    devConfig.geturlApi() + 'Agent/GetMarketingStats', // API endpoint
                    '{ "AgentId":' +
                        cur_user +
                        ', "FromDateLocal":"' +
                        dateRange.FromDateLocal +
                        '", "ToDateLocal":"' +
                        dateRange.ToDateLocal +
                        '"}',
                    {
                        error: function (text, data, XmlHttpRequest) {
                            // Error handling
                            webix.message('Error! '); // Display error message
                        },
                        success: function (text, data, XmlHttpRequest) {
                            // Success handling
                            var data = JSON.parse(text); // Parse the response data
                            initThis.app.callEvent(
                                'statisticsAgent:marketing',
                                [data.result.charts.MediaStat.records], // Trigger event with marketing data
                            );
                            initThis.app.callEvent('statisticsAgent:marketingvsregistros', [
                                data.result.charts.MarketingVsRegistros.records, // Trigger event with marketing vs registrations data
                            ]);
                            initThis.app.callEvent(
                                'statisticsAgent:MoneyUsers',
                                [data.result.charts.MoneyUsers.records], // Trigger event with money users data
                            );
                            initThis.app.callEvent(
                                'statisticsAgent:ageUsersStat',
                                [data.result.charts.AgeUsers.records], // Trigger event with age users statistics data
                            );
                        },
                    },
                );
        });
        this.$$('fechaRango') // Attach event to the date range picker popup
            .getPopup()
            .attachEvent('onhide', function () {
                const dateRange = initThis.$$('myform').getValues(); // Get selected date range values
                var fromDateLocal = // Calculate starting date in local format
                    dateRange.regDateRange.start.getFullYear() +
                    ':' +
                    ('00' + (dateRange.regDateRange.start.getMonth() + 1)).slice(-2) +
                    ':' +
                    ('00' + dateRange.regDateRange.start.getDate()).slice(-2) +
                    ' ' +
                    ('00' + dateRange.regDateRange.start.getHours()).slice(-2) +
                    ':' +
                    ('00' + dateRange.regDateRange.start.getMinutes()).slice(-2) +
                    ':' +
                    ('00' + dateRange.regDateRange.start.getSeconds()).slice(-2);
                var toDateLocal = // Calculate ending date in local format
                    dateRange.regDateRange.end.getFullYear() +
                    ':' +
                    ('00' + (dateRange.regDateRange.end.getMonth() + 1)).slice(-2) +
                    ':' +
                    ('00' + dateRange.regDateRange.end.getDate()).slice(-2) +
                    ' ' +
                    ('00' + dateRange.regDateRange.end.getHours()).slice(-2) +
                    ':' +
                    ('00' + dateRange.regDateRange.end.getMinutes()).slice(-2) +
                    ':' +
                    ('00' + dateRange.regDateRange.end.getSeconds()).slice(-2);
                const dateFilter = {
                    // Create date filter object
                    FromDateLocal: fromDateLocal,
                    ToDateLocal: toDateLocal,
                };
                initThis.app.callEvent('statisticsAgent:date', [dateFilter]); // Trigger event with date filter
            });
    }
}

// FILE DOCUMENTED
